module.exports = __webpack_public_path__ + "static/media/stay.4ed76d64.svg";